import { render, staticRenderFns } from "./commit_popover.vue.js?vue&type=template&id=a72176e2&vue3!=!../../../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./commit_popover.vue?vue&type=template&id=a72176e2&vue3"
import script from "./commit_popover.vue.js?vue&type=script&lang=js&vue3!=!../../../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./commit_popover.vue?vue&type=script&lang=js&vue3"
export * from "./commit_popover.vue.js?vue&type=script&lang=js&vue3!=!../../../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./commit_popover.vue?vue&type=script&lang=js&vue3"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports